export enum FLOW {
  DOCTOR_ESCRIPT = 'doctorEscript',
  NO_RX = 'noRX',
  RETRIEVAL = 'retrieval',
  TRANSFER = 'transfer',
}

export const MATCH_TYPE = {
  FULL_ONLY_ONE_MATCH: 'full_only_one_match',
  PARTIAL_OR_MULTIPLE_MATCH: 'partial_or_multiple_match',
  NONE_MATCH: 'none_match',
};

export enum SIGNUP_SOURCES {
  WEB_ACCOUNT_CREATION = 'web_account_creation',
  WEB_TRANSFER_FLOW = 'web transfer flow',
  WEB_ESCRIPT_FLOW = 'web_escript_flow',
  DOCTOR_CHANNEL = 'escript',
  PROMOTION = 'promotion',
}

export enum REFERRAL_TYPE {
  DOCTOR = 'doctor',
}
